import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)

  async function handleReset() {
    if (!email) { setError('Please enter your email address.'); return }
    setLoading(true)
    setError(null)
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    })
    if (resetError) { setError(resetError.message); setLoading(false); return }
    setSent(true)
    setLoading(false)
  }

  return (
    <div>
      <nav className="topnav">
        <a href="/" className="topnav-logo">PREDICTA</a>
        <a href="/login" className="btn btn-secondary" style={{ padding: '7px 16px', fontSize: '13px' }}>Log in</a>
      </nav>
      <div className="container-narrow">
        <div style={{ textAlign: 'center', paddingTop: '48px', marginBottom: '32px' }}>
          <h1 style={{ fontFamily: 'var(--ff-d)', fontWeight: '700', fontSize: '36px', marginBottom: '8px' }}>Reset password</h1>
          <p style={{ color: 'var(--text-2)' }}>Enter your email and we'll send you a reset link</p>
        </div>
        <div className="card">
          {sent ? (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ fontSize: '40px', marginBottom: '16px' }}>📧</div>
              <h3 style={{ fontFamily: 'var(--ff-d)', fontSize: '22px', marginBottom: '8px' }}>Check your email</h3>
              <p style={{ color: 'var(--text-2)', fontSize: '13px', marginBottom: '24px', lineHeight: '1.7' }}>
                We've sent a reset link to {email}. Follow the link to set a new password.
              </p>
              <a href="/login" className="btn btn-secondary">Back to login</a>
            </div>
          ) : (
            <>
              {error && (
                <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 'var(--r)', padding: '10px 14px', marginBottom: '16px' }}>
                  <p style={{ color: 'var(--red)', fontSize: '13px' }}>{error}</p>
                </div>
              )}
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Email address</label>
                <input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleReset()} />
              </div>
              <button className="btn btn-primary" onClick={handleReset} disabled={loading} style={{ width: '100%', padding: '12px' }}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
              <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px' }}>
                <a href="/login" style={{ color: 'var(--text-3)' }}>Back to login</a>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}